import * as React from 'react';
import { cn } from '@utils';

export const ListPageLayoutLoadMoreSentinel = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div
			ref={ref}
			className={cn('h-1 w-full', className)}
			data-testid="list-page-layout-load-more-sentinel"
			aria-hidden
			{...props}
		/>
	)
);
ListPageLayoutLoadMoreSentinel.displayName = 'ListPageLayoutLoadMoreSentinel';
